import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';
import { TableCell, TableRow } from '@mui/material';

const FacilityWarrantyComponent = ({ facilityWarranty, index }) => {
  return (
    <TableRow>
      <TableCell>
        <TextField
          id={index + '_warrantyTypeName'}
          name='warrantyTypeName'
          fullWidth
          disabled={true}
          value={facilityWarranty && facilityWarranty.dictionaryWarrantyTypeName ? facilityWarranty.dictionaryWarrantyTypeName : ''}
        />
      </TableCell>
      <TableCell>
        <TextField
          id={index + '_guarantorName'}
          name='guarantorName'
          fullWidth
          disabled={true}
          value={
            facilityWarranty && facilityWarranty.guarantor && facilityWarranty.guarantor.guarantorName
              ? facilityWarranty.guarantor.guarantorName
              : ''
          }
        />
      </TableCell>
      <TableCell>
        <TextField
          id={index + '_issuerName'}
          name='issuerName'
          fullWidth
          disabled={true}
          value={
            facilityWarranty && facilityWarranty.issuer && facilityWarranty.issuer.issuerName ? facilityWarranty.issuer.issuerName : ''
          }
        />
      </TableCell>
      <TableCell>
        <TextField
          id={index + '_amount'}
          isNumeric={true}
          name='amount'
          fullWidth
          disabled={true}
          value={facilityWarranty && facilityWarranty.amount ? facilityWarranty.amount : ''}
        />
      </TableCell>
      <TableCell>
        <TextField
          id={index + '_currency'}
          name='currency'
          fullWidth
          disabled={true}
          value={facilityWarranty && facilityWarranty.currencyCode ? facilityWarranty.currencyCode : ''}
        />
      </TableCell>
      <TableCell>
        <DateTime id={index + '_validFrom'} name='validFrom' fullWidth disabled={true} value={facilityWarranty?.validFrom} />
      </TableCell>
      <TableCell>
        <DateTime id={index + '_validTo'} name='validTo' fullWidth disabled={true} value={facilityWarranty?.validTo} />
      </TableCell>
    </TableRow>
  );
};
FacilityWarrantyComponent.propTypes = {
  facilityWarranty: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

export default FacilityWarrantyComponent;
